import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { NumberTextField } from 'shared/controls';
import { ExpenseForm, Brands } from 'shared/types';
import { ExpenseTypeDropdown } from './expense-type-dropdown';

export function NewExpenseFields() {
  const {
    formState: { errors },
  } = useFormContext<ExpenseForm>();
  const { brand } = useParams<{ brand: Brands }>();
  const isNianticBrand: boolean = brand === 'nianticseal';

  return (
    <Grid container spacing={1} pt={1}>
      <Grid xs={12} item>
        <ExpenseTypeDropdown name='type' error={errors.type} />
      </Grid>
      <Grid xs={12} item>
        <NumberTextField
          prefix='$'
          name='price'
          label='Price'
          decimalScale={isNianticBrand ? 4 : 2}
          rules={{
            required: { message: 'Price is required', value: true },
          }}
          error={Boolean(errors?.price)}
          helperText={errors?.price?.message}
        />
      </Grid>
      <Grid xs={12} item>
        <NumberTextField
          name='quantity'
          label='Quantity'
          rules={{
            required: { message: 'Quantity is required', value: true },
          }}
          error={Boolean(errors?.quantity)}
          helperText={errors?.quantity?.message}
        />
      </Grid>
    </Grid>
  );
}
